module.exports = __webpack_public_path__ + "static/ppf-1-ea4d563385c92aa11401357922d87372.jpg";